import script from "./GeoblockRuleCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeoblockRuleCard.vue?vue&type=script&lang=ts&setup=true"

import "./GeoblockRuleCard.vue?vue&type=style&index=0&id=b86d0cc6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b86d0cc6"]])

export default __exports__